import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import ContentLoader from 'react-content-loader';

function BubbleEmployeeLoader(props) {
  return jsxs(Fragment, {
    children: [jsxs(ContentLoader, {
      viewBox: "0 0 480 170",
      height: 170,
      className: "w-full md:hidden",
      ...props,
      children: [jsx("circle", {
        cx: "33",
        cy: "140",
        r: "27"
      }), jsx("rect", {
        x: "6",
        y: "1",
        rx: "4",
        ry: "4",
        width: "408",
        height: "105"
      }), jsx("rect", {
        x: "84",
        y: "131",
        rx: "4",
        ry: "4",
        width: "151",
        height: "8"
      }), jsx("rect", {
        x: "84",
        y: "154",
        rx: "4",
        ry: "4",
        width: "151",
        height: "8"
      })]
    }), jsxs(ContentLoader, {
      viewBox: "0 0 480 140",
      height: 140,
      className: "hidden w-full md:block",
      ...props,
      children: [jsx("circle", {
        cx: "29",
        cy: "87",
        r: "27"
      }), jsx("rect", {
        x: "70",
        y: "1",
        rx: "4",
        ry: "4",
        width: "408",
        height: "105"
      }), jsx("rect", {
        x: "7",
        y: "128",
        rx: "4",
        ry: "4",
        width: "151",
        height: "8"
      })]
    })]
  });
}

export { BubbleEmployeeLoader };
